import { Navigate, useLocation } from "react-router";
import type { ReactNode } from "react";

import { useAuth } from "@/hooks/useAuth";

// Reproduces the Next.js middleware.ts guard on the client.
// Middleware checked the `better-auth.session_token` cookie at the edge;
// react-router does the same check via useAuth() and redirects to "/".
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-300 border-t-slate-900" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return <>{children}</>;
}
